var factsheetHeader = {
	label: {
		highLowBar: "Fourchette intraday:",
		lastPriceDateTime: "Date/Heure:",
		volume: "Quantité:",
		isin: "ISIN",
		wkn: "WKN",
		numberOfConstituents: "Nombre de Constituants",
		country: "Pays",
		symbol: "Symbole",
		fundIssuer: "Émetteur",
		fundCategory: "Catégorie",
		pea: "PEA",
		pme: "PEA-PME",
		srd: "SRD",
		tradingStatus: "Statut de Négociation",
		perf1Year: "Perf. 1 an",
		perf5Years: "Perf. 5 ans",
		perf1Week: "Perf. 1 Semaine",
		perf1Month: "Perf. 1 mois",
		suspended: "Suspendu",
		marketStatus: "État du Marché",
		tradingPhase: "Phase de Négociation",
		expectedDividends: "Dividendes Attendus",
		expectedPriceEarningsRatio: "Ratio Cours/Bénéfice Attendu"
	},
	"true": "Oui",
	"false": "Non",
	open: "Ouvert",
	close: "Fermé"
};
var fr = {
	factsheetHeader: factsheetHeader
};

export { fr as default, factsheetHeader };
